const Rails = require('@rails/ujs')

// 初期化処理
import Initializer  from 'lib/initializer'
import RailsUjsJack from 'lib/rails_ujs_jack'

RailsUjsJack.jack(Rails);
Rails.start();
Initializer.lazy();

// turbolinksでのリクエスト時に発動
document.addEventListener('turbolinks:load', () => {

  Initializer.lazy();
});

// react
import WebpackerReact from 'webpacker-react'

// 汎用モーダル
import DataModal from 'works/data_modal'

WebpackerReact.setup({
  DataModal,
})
